/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */

export type StatementActivityType =
  (typeof StatementActivityType)[keyof typeof StatementActivityType];

export const StatementActivityType = {
  Statement: "Statement",
  Reminder1: "Reminder1",
  Reminder2: "Reminder2",
  Reminder3: "Reminder3",
  AutochargeFailed: "AutochargeFailed",
  PaymentReceived: "PaymentReceived",
  ExternallyPaid: "ExternallyPaid",
  AutochargeScheduled: "AutochargeScheduled",
  ManuallyResent: "ManuallyResent",
} as const;
